export default __webpack_public_path__ + "static/BrandonGrotesque-Regular-591bd2b98eed5cdcc9980efd8fd1a9e7.woff2";